var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"personality-test-results-detailed"},_vm._l((_vm.results),function(domain){return _c('div',{key:domain.id},[_c('ResultsDetailedSection',{attrs:{"domain":domain}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }